function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M24 9.611L22.389 8 16 14.389 9.611 8 8 9.611 14.389 16 8 22.389 9.611 24 16 17.611 22.389 24 24 22.389 17.611 16z"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close.c0cc79df.svg";
export { SvgClose as ReactComponent };